// Extracted from `pages/CustomerDetailPage.js` (P2 refactor step 4c).
// Tab "Proyectos" — 1:1 move del JSX. Lista los proyectos del cliente,
// muestra los servicios agrupados y permite crear/editar/borrar. El botón
// "Nuevo Proyecto" abre el `ProjectModal` que vive en el padre.
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { FolderKanban, Plus, Link2, Edit2, Trash2 } from "lucide-react";

export const ProyectosTab = ({
  projects,
  services,
  setProjectModalOpen,
  openEditProject,
  handleDeleteProject,
}) => {
  return (
    <Card className="bg-[#0A0A35] border-[#1E1E5F]">
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle className="text-white font-heading flex items-center gap-2">
            <FolderKanban className="h-5 w-5 text-purple-400" />
            Proyectos
          </CardTitle>
          <CardDescription className="text-slate-400">
            Agrupa servicios relacionados en proyectos
          </CardDescription>
        </div>
        <Button
          onClick={() => setProjectModalOpen(true)}
          className="bg-[#42E695] text-[#04042C] hover:bg-[#34D399]"
          data-testid="new-project-btn"
        >
          <Plus className="h-4 w-4 mr-2" />
          Nuevo Proyecto
        </Button>
      </CardHeader>
      <CardContent>
        {projects.length === 0 ? (
          <div className="text-center py-12 text-slate-400">
            <FolderKanban className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p>No hay proyectos creados</p>
            <p className="text-sm mt-2">
              Los proyectos permiten agrupar servicios relacionados
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {projects.map((project) => (
              <Card key={project.id} className="bg-[#1B1B4B]/50 border-[#1E1E5F]">
                <CardContent className="pt-4">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-3">
                        <FolderKanban className="h-5 w-5 text-purple-400" />
                        <h4 className="text-white font-medium text-lg">{project.name}</h4>
                        <Badge className="bg-purple-500/20 text-purple-400">
                          {project.services_count || 0} servicio(s)
                        </Badge>
                      </div>
                      {project.description && (
                        <p className="text-slate-400 mt-2 ml-8">{project.description}</p>
                      )}

                      {/* Services in project */}
                      {project.service_ids?.length > 0 && (
                        <div className="mt-4 ml-8 space-y-2">
                          <p className="text-xs text-slate-500 uppercase">Servicios incluidos:</p>
                          <div className="flex flex-wrap gap-2">
                            {project.service_ids.map(sid => {
                              const svc = services.find(s => s.id === sid);
                              return svc ? (
                                <Badge key={sid} className="bg-[#03BEE4]/20 text-[#03BEE4]">
                                  <Link2 className="h-3 w-3 mr-1" />
                                  {svc.nombre_servicio}
                                </Badge>
                              ) : null;
                            })}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="flex gap-2">
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => openEditProject(project)}
                        className="text-[#03BEE4] hover:text-[#03BEE4]/80"
                      >
                        <Edit2 className="h-4 w-4" />
                      </Button>
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => handleDeleteProject(project.id)}
                        className="text-red-400 hover:text-red-300"
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
